import React from 'react';
import {ExcelService} from "../services";
import {Col, Row} from "react-bootstrap";
import Document from "./Icons/Document";
import CancelCircle from "./Icons/CancelCircle";
import Folder from "../assets/images/Folder.svg";

function ExcelGenerator(props) {

  const generateExcel = async () => {
    if (!props.headers?.length || !props.data?.length) {
      return;
    }

    await ExcelService.generateDownloadLetterExcel(props.headers, props.data);
  };

  return (
      <Row className="background-1 file-box file-box-exel">
        <Row className="background-1" onClick={generateExcel}>
          <img src={Folder} alt="Extensis HR" className="icon-upload mb-1"/>
          <span className="span-upload-label mb-1">Download Template</span>
        </Row>
      </Row>
  );
}

export default ExcelGenerator;
